<template>
  <div class="million-read-vip-term">
    <div class="million-read-vip-term-content"
         v-html="content"
    ></div>
  </div>
</template>

<script>
  import { getVipUserTerm } from '@/services/million-read';

  export default {
    name: 'MillionReadVipTerm',
    metaInfo() {
      return {
        title: this.render.pageTitle,
      };
    },
    data() {
      return {
        content: '',
        render: {
          pageTitle: '',
        },
      };
    },
    computed: {
      id() {
        const { $route } = this;
        return $route.query && $route.query.id ? parseInt($route.query.id, 10) : 0;
      },
    },
    methods: {
      async fetchData() {
        const data = await getVipUserTerm(this.id);
        this.content = data.content;
        this.render = data.render;
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-vip-term {
    box-sizing: border-box;
    min-height: 100%;
    padding: @size-base;
    background: @color-white;

    &-content {
      color: @color-text-light;
      line-height: 1.5;
    }
  }

</style>
